"use client";

import { useEffect } from "react";
import { supabase } from "@/lib/supabase";
import { applyAccentTheme, fetchAccentTheme } from "@/lib/accentTheme";

export default function ThemeBootstrap() {
  useEffect(() => {
    async function loadAccentTheme() {
      const { data } = await supabase.auth.getUser();
      const user = data?.user;
      if (!user) return;

      const theme = await fetchAccentTheme(user.id);
      applyAccentTheme(theme);
    }

    loadAccentTheme();
  }, []);

  return null;
}
